<template>
  <el-dialog
    class="dialog-title"
    title="5秒免费生成投放策略"
    :visible.sync="dialog"
    center
    width="1200px">
    <div class="dialog-att">专业营销大数据平台，14年行业经验，累计服务1000余家企业，持续合作企业90%以上</div>
    <el-row v-if="hackReset">
      <el-col :span="12">
        <div class="grid-content" style="border-right: 1px dotted #999;padding-right: 100px;box-sizing: border-box">
          <div class="grid-title">填写需求</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="品牌名称" prop="brand" maxlength="50" :rules="[{ required: true, message: '请填写品牌名称', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }]">
              <el-input v-model="ruleForm.brand" width="200px"></el-input>
            </el-form-item>
            <el-form-item label="行业" prop="industry" :rules="[{ required: true, message: '必选', trigger: 'change' }]">
              <el-cascader
                :options="indust"
                v-model="ruleForm.industry"
                @change="handleChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="公司所在地" prop="comAdress" :rules="[{ required: true, message: '必选', trigger: 'change' }]">
              <area-select type='all' :placeholders="placeholders" :level='1' v-model="ruleForm.comAdress" :data="pcaa"></area-select>
            </el-form-item>
            <el-form-item label="是否有分公司" :rules="{ required: true, message: '请选择）', trigger: 'change' }">
              <el-radio-group v-model="ruleForm.flag">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :rules="[{ required: true, message: '必选', trigger: 'change' }]"
              v-if="ruleForm.flag === '是'"
              label="分公司所在地"
              v-for="(domain, index) in ruleForm.domains"
              :label="'分公司' + (index + 1)"
              :key="domain.key"
              :prop="'domains.' + index + '.sonCompanys'">
              <area-select type='all' :placeholders="placeholders" :level='1' v-model="domain.sonCompanys" :data="pcaa"  class="add-inp"></area-select>
              <div class="add-btn">
                <el-button v-if="index !== 0" class="delete" type="text" @click.prevent="removeDomain(domain)">删除</el-button>
                <span v-else></span>
                <el-button class="add" type="text" @click="addDomain()">添加</el-button>
              </div>
            </el-form-item>
            <el-form-item label="投资加盟费用" prop="money" :rules="[{ required: true, message: '必选', trigger: 'change' }]">
              <el-select v-model="ruleForm.money" placeholder="请选择">
                <el-option label="1 - 5 万" value="0"></el-option>
                <el-option label="6 - 10 万" value="1"></el-option>
                <el-option label="11 - 15 万" value="2"></el-option>
                <el-option label="16 - 20 万" value="3"></el-option>
                <el-option label="21 - 25 万" value="4"></el-option>
                <el-option label="26 - 30 万" value="5"></el-option>
                <el-option label="30 - 100 万" value="6"></el-option>
                <el-option label="100 万以上" value="7"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="团队（人数）" prop="people" :rules="[{ required: true, message: '请填写团队（人数）', trigger: 'blur'},
              { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }]">
              <el-input v-model="ruleForm.people"></el-input>
              <span v-if="ruleForm.people > 0 || ruleForm.people === undefined || ruleForm.people === ''"></span>
              <span v-else style="color:#F56C6C;font-size: 12px">数值必须是大于0的数字</span>
            </el-form-item>
            <el-form-item
              :rules="{ required: true, message: '请填写竞争品牌', trigger: 'blur'}"
              v-for="(child, ind) in ruleForm.children"
              :label="'竞争品牌' + (ind + 1)"
              :key="child.key"
              :prop="'children.' + ind + '.comBrand'"
              label="竞争品牌">
              <el-input v-model="child.comBrand" class="add-inp"></el-input>
              <div class="add-btn">
                <el-button v-if="ind !== 0" class="delete" type="text" @click.prevent="removeDomains(child)">删除</el-button>
                <span v-else></span>
                <el-button class="add" type="text" @click="addDomains()">添加</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <template>
                <el-button type="primary" class="btn" @click="submitForm('ruleForm')" v-if="!flag">提 交</el-button>
                <el-button type="primary" class="btn" v-else disabled>提 交</el-button>
              </template>
              <el-button type="text" @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content" :class="{addMask:isLoad}">
          <div class="grid-title">投放方案</div>
          <div class="grid-chart clear">
            <div class="fl pr">
              <p class="pa sex">性别分布</p>
              <div class="total pa">
                <p>总人数</p><span>{{chartSex.total}}</span>
              </div>
              <ve-ring :data="chartSex" :extend="chartExtend" height="187px"></ve-ring>
            </div>
            <div class="fl pr">
              <p class="pa age">年龄分布</p>
              <div class="total pa">
                <p>总人数</p><span>{{chartAge.total}}</span>
              </div>
              <ve-ring :data="chartAge" :extend="chartExtend" height="187px"></ve-ring>
            </div>
            <div class="fl pr">
              <p class="pa edu">学历分布</p>
              <div class="total pa">
                <p>总人数</p><span>{{chartEdu.total}}</span>
              </div>
              <ve-ring :data="chartEdu" :extend="chartExtend" height="187px"></ve-ring>
            </div>
          </div>
          <div class="grid-info">
            <span>主要分布区域：</span>
            <span class="flag" v-for="item in region">{{item.province + '、'}}</span>
          </div>
          <div class="grid-info">
            <span>预估投放预算：</span>
            <span class="flag">{{budget}}元</span>
          </div>
          <div class="grid-info">
            <p>更多更全面的投放策略已生成，专业顾问王经理将会第一时间与您联系
              为您量身定制投放方案</p>
          </div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="formModify" :rules="rules">
            <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确', trigger: ['blur', 'change']}]">
              <el-input v-model="formInline.telephone" placeholder="联系电话" width="300"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" class="btn">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
  import { pcaa } from 'area-data'
  import Api from '@/api/tourist/strategy-survey'
  export default {
    props: {
      platform: '',
      type: ''
    },
    data () {
      this.chartExtend = {
        legend: {
          left: '140px',
          top: 'middle',
          width: 20,
          itemWidth: 10,
          itemHeight: 10,
          borderRadius: 50,
          formatter: function (name) {
            return name
          }
        },
        series: {
          label: {
            show: false
          },
          center: ['26%', '50%'],
          radius: ['50%', '60%']
        },
        tooltip: {
          trigger: 'none'
        }
      }
      return {
        indust: [],
        pcaa: pcaa,
        flag: false,
        placeholders: ['省、自治区', '市、区'],
        isLoad: true,
        dialog: false,
        hackReset: true,
        ruleForm: {
          flag: '是',
          brand: '',
          industry: [],
          comAdress: [],
          domains: [{sonCompanys: []}],
          money: '',
          people: '',
          children: [{comBrand: ''}]
        },
        chartSex: {
          total: 0,
          columns: ['性别', 'value'],
          rows: [
            { '性别': '男性', 'value': 0 },
            { '性别': '女性', 'value': 0 }
          ]
        },
        chartAge: {
          total: 0,
          columns: ['年龄', 'value'],
          rows: [
            { '年龄': '20岁以下', 'value': 0 },
            { '年龄': '20-29岁', 'value': 0 },
            { '年龄': '30-39岁', 'value': 0 },
            { '年龄': '40-49岁', 'value': 0 },
            { '年龄': '50岁以上', 'value': 0 }
          ]
        },
        chartEdu: {
          total: 0,
          columns: ['学历', 'value'],
          rows: [
            { '学历': '高中及以下', 'value': 0 },
            { '学历': '大专', 'value': 0 },
            { '学历': '本科以上', 'value': 0 }
          ]
        },
        budget: '',
        region: [],
        formInline: {
          telephone: '',
          strategySurveyId: 0,
          message: []
        }
      }
    },
    created () {
      Api.industries(response => {
        let status = response.data.code
        let body = response.data.data || {}
        if (status === '200') {
          let option = []
          for (let key in body) {
            let children = []
            for (let key1 in body[key]) {
              let children1 = []
              body[key][key1].forEach(item => {
                children1.push({value: item.title, label: item.title})
              })
              children.push({value: key1, label: key1, children: children1})
            }
            option.push({value: key, label: key, children: children})
          }
          this.indust = option
        }
      })
    },
    methods: {
      addDomain () {
        this.ruleForm.domains.push({
          sonCompanys: '',
          key: Date.now()
        })
      },
      removeDomain (item) {
        let index = this.ruleForm.domains.indexOf(item)
        if (index !== -1) {
          this.ruleForm.domains.splice(index, 1)
        }
      },
      addDomains () {
        this.ruleForm.children.push({
          comBrand: '',
          key: Date.now()
        })
      },
      removeDomains (ite) {
        let ind = this.ruleForm.children.indexOf(ite)
        if (ind !== -1) {
          this.ruleForm.children.splice(ind, 1)
        }
      },
      submitForm () {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            let forms = {}
            let comAdress = ''
            let sonCompanys = ''
            let comBrand = ''
            for (let key in this.ruleForm.comAdress) {
              for (let key1 in this.ruleForm.comAdress[key]) {
                comAdress += this.ruleForm.comAdress[key][key1]
              }
            }
            this.ruleForm.domains.forEach(item => {
              let sonTem = ''
              for (let key in item) {
                for (let key2 in item[key]) {
                  for (let key3 in item[key][key2]) {
                    sonTem += item[key][key2][key3]
                  }
                }
              }
              sonCompanys += sonTem + ','
            })
            for (let item in this.ruleForm.children) {
              for (let item1 in this.ruleForm.children[item]) {
                comBrand += this.ruleForm.children[item][item1] + ','
              }
            }
            sonCompanys = sonCompanys.substring(0, sonCompanys.lastIndexOf(','))
            comBrand = comBrand.substring(0, comBrand.lastIndexOf(','))
            forms = Object.assign({'brand': this.ruleForm.brand},
              {'industry': this.ruleForm.industry[2]},
              {'comAdress': comAdress},
              {'sonCompanys': sonCompanys},
              {'money': this.ruleForm.money},
              {'people': this.ruleForm.people},
              {'comBrand': comBrand})
            if (this.ruleForm.people > 0) {
              Api.survey({form: forms}, response => {
                let status = response.status
                let data = response.data
                if (status >= 200 && status <= 204) {
                  this.formInline.strategySurveyId = data.id
                  Api.report(data.id, response => {
                    let status1 = response.status
                    this.budget = response.data.map.budget
                    this.region = response.data.map.region
                    let data1 = response.data.map.percent
                    if (status1 >= 200 && status1 <= 204) {
                      this.isLoad = false
                      this.formatChart(data1)
                    }
                  })
                }
              })
            }
            this.flag = true
          } else {
            this.flag = false
            return false
          }
        })
      },
      resetForm (ruleForm) {
        this.flag = false
        this.hackReset = false
        this.$nextTick(() => {
          this.hackReset = true
          this.isLoad = true
        })
        this.ruleForm = {
          flag: '是',
          brand: '',
          industry: [],
          comAdress: [],
          domains: [{sonCompanys: []}],
          money: '',
          people: '',
          children: [{comBrand: ''}]
        }
        this.chartSex = {
          total: 0,
          columns: ['性别', 'value'],
          rows: [
            { '性别': '男性', 'value': 0 },
            { '性别': '女性', 'value': 0 }
          ]
        }
        this.chartAge = {
          total: 0,
          columns: ['年龄', 'value'],
          rows: [
            { '年龄': '20岁以下', 'value': 0 },
            { '年龄': '20-29岁', 'value': 0 },
            { '年龄': '30-39岁', 'value': 0 },
            { '年龄': '40-49岁', 'value': 0 },
            { '年龄': '50岁以上', 'value': 0 }
          ]
        }
        this.chartEdu = {
          total: 0,
          columns: ['学历', 'value'],
          rows: [
            { '学历': '高中及以下', 'value': 0 },
            { '学历': '大专', 'value': 0 },
            { '学历': '本科以上', 'value': 0 }
          ]
        }
        this.$refs[ruleForm].resetFields()
      },
      formatChart (data) {
        this.chartSex.rows[0]['value'] = data.male
        this.chartSex.rows[1]['value'] = data.female
        this.chartSex.total = data.female + data.male
        for (let i = 0; i < 5; i++) {
          this.chartAge.rows[i]['value'] = data['age' + i]
          this.chartAge.total += Number(data['age' + i])
        }
        for (let i = 0; i < 3; i++) {
          this.chartEdu.rows[i]['value'] = data['education' + i]
          this.chartEdu.total += Number(data['education' + i])
        }
      },
      onSubmit () {
        this.$refs['formModify'].validate((valid) => {
          if (valid) {
            let telephone = this.formInline.telephone
            if (telephone !== '' && telephone !== undefined) {
              let formInline = this.formInline
              formInline.type = 3
              formInline.platform = 1
              if (this.$store.state.user.info !== null) {
                Api.createLogin({form: formInline}, response => {
                  let status = response.status || 0

                  let body = response.data || []
                  if (status >= 200 && status <= 204) {
                    // 新数据加到数组开头
                    this.formInline.message.unshift(body)
                    this.$message.success('留言成功')
                  } else {
                    this.$message.error(body.error || '留言失败')
                  }
                  // 关闭
                  this.$refs['slideModifyRow'].close()
                })
                this.form = []
                this.dialog = false
              } else {
                Api.create({form: formInline}, response => {
                  let status = response.data.code

                  let body = response.data
                  if (status === '200') {
                    // 新数据加到数组开头
                    this.formInline.message.unshift(body.data)
                    this.$message.success('留言成功')
                  } else {
                    this.$message.error(body.msg || '留言失败')
                  }
                  // 关闭
                  this.$refs['slideModifyRow'].close()
                })
                this.form = []
                this.dialog = false
              }
            } else {
              this.$message.error('信息不能为空')
            }
          } else {
            return false
          }
          this.form = []
        })
      },
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
      }
    }
  }
</script>
<style scoped lang="scss">
  .dialog-title{
    .dialog-att {
      position: absolute;
      top: 60px;
      left: 300px;
      color: #666;
      font-size: 16px;
    }
    .grid-content {
      padding: 20px 40px;
      box-sizing: border-box;
      .demo-ruleForm{
        .add-btn{
          width: 100%;
          height: 100%;
          background-color: red;
          float: right;
          position: relative;
          .delete{
            position: absolute;
            right: -75px;
            top: -35px;
            color:#999;
          }
          .add{
            position: absolute;
            right: -40px;
            top: -35px;
            color:#999;
          }
        }
      }
      > .grid-title {
        width: 80px;
        height: 30px;
        margin: 0 auto 30px;
        text-align: center;
        border-bottom: 1px solid #2c80e5;
      }
      .grid-chart{
        >div{
          width:50%;
          p{margin:0;}
          .total{
            text-align: center;
            top: 50%;
            left: 26%;
            transform: translate(-50%, -50%);
            p{
              color:#999999;
              font-size:12px;
              margin-bottom: 3px;
            }
            span{
              color:#666666;
              font-size:16px;
            }
          }
        }
      }
      .grid-info{
        margin-bottom:30px;
        .flag{
          color:#1770e6;
        }
      }
      .grid-info p{line-height:22px;}
    }
    .addMask{
      position: relative;
      width:100%;
      height:100%;
      &::after{
        content: '免费生成投放策略';
        position: absolute;
        color: rgba(255, 255, 255, 0.88);
        line-height: 700px;
        text-align: center;
        font-size: 30px;
        letter-spacing: 4px;
        width:100%;
        height:100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.76);
      }
    }
  }
</style>
<style lang="scss">
  .dialog-title > .el-dialog > .el-dialog__header {
    height: 80px;
    background: #f9f9f9;
    position: relative;
  }
  .dialog-title > .el-dialog > .el-dialog__header > .el-dialog__title {
    font-size: 20px;
    color: #085ecc;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.area-select-wrap>.area-select>.area-selected-trigger{
    line-height: 20px;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.area-select-wrap>.area-select>.area-selected-trigger{
    line-height: 20px;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.area-select-wrap>.area-select{
    margin: 0;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.area-select-wrap>.area-select>.area-selectable-list-wrap>.area-selectable-list>.selected{
    color: #085ecc;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.area-select-wrap>.area-select{
    width: 152px;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.el-cascader{
    display: block;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.el-select{
    display: block;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.btn {
    width: 156px;
    height: 40px;
    outline: none;
    border: none;
    background: #085ecc;
    margin-right: 20px;
  }
  .dialog-title >.el-dialog>.el-dialog__body>.el-row>.el-col>.grid-content>.el-form>.el-form-item>
  .el-form-item__content>.btn:hover {
    background: #4a98ff;
    transition-duration: 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/tourist/common/DeliveryStrategy.vue